import {AxiosRequestConfig, AxiosResponse} from 'axios';

import * as toastr from "toastr";
import urlencode from "urlencode";

import {FilterXSS} from "xss";
import history from '../config/history';
import {actions} from '../reducers/boCore';
import {disableSpinner, enableSpinner} from './topHeaderActions';
import {Attribute} from "../components/bo-core/models/Attribute";
import {BusinessObject} from "../components/bo-core/models/BusinessObject";
import {AttributeValue} from "../components/bo-core/models/AttributeValue";
import ActionSpinner from "../components/common/ActionSpinner";
import Axios from "../config/Axios";
import store from "../config/store";
import {setSpinner} from "./actionSpinnerActions";
import {actions as spinnerActions} from "../reducers/actionSpinner";
import {EVENTS} from "../config/boCore";
import Utils from "../Utils";

const myxss = new FilterXSS({
    whiteList: {}
});

export const createGraphQLRequest = (query: any, successCallback: any, errorCallback: any) => {
    graphQlRequest(query)
        .then((response) => {
            if (Object.keys(response.data).includes('errors')) {
                errorCallback(response.data.errors[0]);
            } else {
                successCallback(response.data.data);
            }
        })
        .catch(error => {
            errorCallback(error);
        })
};

export const fetchAllBusinessObjects = (args?: object) => {
    const msg = "Business Objects Are Being Fetched.";
    return (dispatch) => {
        dispatch({type: actions.FETCH_ALL_BUSINESS_OBJECTS_PENDING});
        dispatch(enableSpinner(msg));
        ActionSpinner.get(`type/all`, {}, {key: "fetchAllBusinessObjects", showOnError: true}, false)
            .then(response => {
                dispatch(
                    {
                        type: actions.FETCH_ALL_BUSINESS_OBJECTS_DISPATCH_SUCCESS,
                        payload: response.data,
                        args
                    }
                );
                dispatch(disableSpinner(msg));
            }).catch((e) => {
            dispatch(
                {
                    type: actions.FETCH_ALL_BUSINESS_OBJECTS_DISPATCH_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
        })
    }
};

export const getBoTypeById = async (typeId: number): Promise<AxiosResponse> => {
    try {
        return await Axios.instanceV2.get(`type/${typeId}`)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const getBoTypeAll = async (): Promise<AxiosResponse> => {
    try {
        return await Axios.instanceV2.get(`type/all`)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const graphQlRequest = async (query: any): Promise<AxiosResponse> => {
    try {
        return await Axios.graphqlInstance.post(`graphql`, query)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const bulkUpdateInstances = async (typeKey: string, bulkUpdateDto: Object): Promise<AxiosResponse> => {
    try {
        return await Axios.instanceV2.post(`data/${typeKey}/bulk-update`, bulkUpdateDto)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const addAttributeValuesToEmailAttribute = async (attributeId: number, attributeValuesDto: Object): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.post(`/boc/attribute/${attributeId}/email-values`, attributeValuesDto)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const getAllBusinessObjects = async (): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.get(`/boc/all`)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const createBusinessObject = (businessObject: object, args: object, uniqueNameObj?: any) => {
    return (dispatch) => {
        dispatch({type: actions.CREATE_BUSINESS_OBJECT_RECORD_PENDING});
        ActionSpinner.post(`boc`, businessObject, {}, {
            key: "createBusinessObject",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Created Successfully."
        })
            .then(response => {
                if (uniqueNameObj) {
                    response.data.attributes.find(attribute => {
                        return attribute.name === 'Name';
                    }).unique = uniqueNameObj.uniqueName;
                }
                dispatch(
                    {
                        type: actions.CREATE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args: args
                    }
                );
                if (uniqueNameObj) {
                    const boClass = {...response.data};
                    boClass['uniqueName'] = true;
                    dispatch(updateBOUniqueNameAttribute(response.data.id, uniqueNameObj.uniqueName, {
                        boClass: boClass,
                        event: EVENTS.boView.typesGrid.update,
                        showSuccessMessage: false
                    }));
                }
            }).catch((e) => {
            dispatch(
                {
                    type: actions.CREATE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const updateBOUniqueNameAttribute = (id: number, isUnique: boolean,
                                            args: { boClass: object, event: string, showSuccessMessage: boolean }) => {
    return (dispatch) => {
        dispatch({type: actions.UPDATE_UNIQUE_NAME_ATTRIBUTE_PENDING});
        ActionSpinner.put(`administrator/type/${id}/attribute/name/unique?isUnique=${isUnique}`, {}, {}, {
            key: "updateBOUniqueNameAttribute",
            showOnError: true,
            showOnSuccess: args.showSuccessMessage,
            onSuccessMessage: "Unique Name Attribute Updated Successfully."
        }, false)
            .then(response => {
                dispatch(
                    {
                        type: actions.UPDATE_UNIQUE_NAME_ATTRIBUTE_DISPATCH_SUCCESS,
                        payload: args.boClass,
                        args: args
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_UNIQUE_NAME_ATTRIBUTE_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const updateBusinessObject = (id: number, args: { boClass: object, event: string}, uniqueNameObj?: any) => {
    return (dispatch) => {
        dispatch({type: actions.UPDATE_BUSINESS_OBJECT_RECORD_PENDING});
        ActionSpinner.put(`boc/${id}`, args.boClass, {}, {
            key: "updateBusinessObject",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Updated Successfully."
        })
            .then(response => {
                dispatch({
                    type: actions.UPDATE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS,
                    payload: response.data,
                    args: args
                });
                if (uniqueNameObj) {
                    dispatch(updateBOUniqueNameAttribute(uniqueNameObj.id, uniqueNameObj.uniqueName, {
                        boClass: uniqueNameObj,
                        event: EVENTS.boView.typesGrid.update,
                        showSuccessMessage: false
                    }));
                }
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const deleteBusinessObject = (id: number, args: object) => {
    return (dispatch) => {
        dispatch({type: actions.DELETE_BUSINESS_OBJECT_RECORD_PENDING});
        ActionSpinner.delete(`boc/${id}`, {}, {
            key: "deleteBusinessObject",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Deleted Successfully."
        })
            .then(() => {
                dispatch(
                    {
                        type: actions.DELETE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS,
                        payload: {id: id},
                        args: args
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.DELETE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const createBusinessObjectAttribute = (attribute: object, args: any) => {
    return (dispatch,) => {
        dispatch({type: actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING});
        ActionSpinner.post(`boc/attribute`, attribute, {}, {
            key: "createBusinessObjectAttribute",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Attribute Created Successfully."
        })
            .then(response => {
                dispatch(
                    {
                        type: actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args: args
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const updateBusinessObjectAttribute = (id: number, dto: object, args: object) => {
    return (dispatch) => {
        dispatch({type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING});
        ActionSpinner.put(`boc/attribute/${id}`, dto, {}, {
            key: "updateBusinessObjectAttribute",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Attribute Updated Successfully."
        })
            .then(response => {
                dispatch(
                    {
                        type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args: args
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const convertBusinessObjectAttributeType = (attributeId: any, convertAttributeTypeDTO: any, args: any) => {
    return (dispatch) => {
        dispatch({type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING});
        ActionSpinner.post(`/administrator/boc/attribute/${attributeId}/convert`, convertAttributeTypeDTO, {}, {
            key: "convertBusinessObjectAttributeType",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Attribute Converted Successfully."
        }, false)
            .then(response => {
                dispatch(
                    {
                        type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS,
                        payload: Utils.attributeV1ModelToV2Model(response.data),
                        args: args
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const deleteBusinessObjectAttribute = (id: number, args: object) => {
    return (dispatch) => {
        dispatch({type: actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING});
        ActionSpinner.delete(`boc/attribute/${id}`, {}, {
            key: "deleteBusinessObjectAttribute",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Attribute Deleted Successfully."
        })
            .then(response => {
                dispatch(
                    {
                        type: actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args: args,
                        id: id
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const createBusinessObjectRelationship = (dto, args) => {
    return (dispatch) => {
        dispatch({type: actions.CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING});
        ActionSpinner.post(`boc/relType`, dto, {}, {
            key: "createBusinessObjectRelationship",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Relationship Created Successfully."
        })
            .then(response => {
                dispatch(
                    {
                        type: actions.CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args: args
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const updateBusinessObjectRelationship = (id: number, dto: object, args: object) => {
    return (dispatch) => {
        dispatch({type: actions.UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING});
        ActionSpinner.put(`boc/relType/${id}`, dto, {}, {
            key: "updateBusinessObjectRelationship",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Relationship Updated Successfully."
        })
            .then(response => {
                dispatch(
                    {
                        type: actions.UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args: args
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const deleteBusinessObjectRelationship = (id, args) => {
    return (dispatch) => {
        dispatch({type: actions.DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING});
        ActionSpinner.delete(`boc/relType/${id}`, {}, {
            key: "deleteBusinessObjectRelationship",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Relationship Deleted Successfully."
        })
            .then(response => {
                dispatch(
                    {
                        type: actions.DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args: args,
                        id: id
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const createBusinessObjectAttributeValue = (args: { attribute: Attribute, boClass: BusinessObject }, dto: { name: string, description: string }) => {
    return (dispatch) => {
        dispatch({type: actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING});
        ActionSpinner.post(`boc/attribute/${args.attribute.id}/values`, [dto], {}, {
            key: "createBusinessObjectAttributeValue",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Business Object Attribute Value Created Successfully."
        })
            .then(response => {
                dispatch(
                    {
                        type: actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS,
                        payload: response.data.attributeValues,
                        args: args,
                        name: dto.name
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR,
                }
            );
        })
    }
};

export const updateBusinessObjectAttributeValue = (args: { attribute: Attribute, attributeValue: AttributeValue, boClass: BusinessObject }, dto) => {
    const msg = "Business Оbject Attribute Value Is Being Updated.";
    return (dispatch) => {
        dispatch({type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.put(`boc/attribute/${args.attribute.id}/value/${args.attributeValue.id}`, dto)
            .then(response => {
                dispatch(
                    {
                        type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args
                    }
                );
                dispatch(disableSpinner(msg));
                toastr.success("Business Object Attribute Value Updated Successfully.")
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const deleteBusinessObjectAttributeValue = (args: { bocId: number, attributeId: number, attributeValueId: number, event: string }) => {
    const msg = "Business Оbject Attribute Value Is Being Deleted.";
    return (dispatch) => {
        dispatch({type: actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.delete(`boc/attribute/${args.attributeId}/value/${args.attributeValueId}`)
            .then(response => {
                dispatch(
                    {
                        type: actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS,
                        payload: response.data,
                        args
                    }
                );
                dispatch(disableSpinner(msg));
                toastr.success("Business Object Attribute Value Deleted Successfully.")
            }).catch((e) => {
            dispatch(
                {
                    type: actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const deleteBusinessObjectAttributeValues = (attributeId: number, dto: object, successCallBack?: any, rejectCallBack?: any) => {
    return (dispatch) => {
        Axios.instanceV2.delete(`administrator/attribute/${attributeId}/values/delete`, {data: dto})
            .then((response: any) => {
                if (successCallBack) {
                    successCallBack(response);
                }
            }).catch(e => {
            if (rejectCallBack) {
                rejectCallBack(e);
            } else {
                showError(e);
            }
        })
    }
};

export const fetchBOInstanceById = (id, dataView) => {
    return (dispatch) => {
        dispatch({type: actions.FETCH_BO_INSTANCE_BY_ID_PENDING});
        ActionSpinner.get(`boi/${id}/?dataView=${dataView}`, {}, {key: "fetchBOInstanceById", showOnError: true})
            .then(response => {
                dispatch(
                    {
                        type: actions.FETCH_BO_INSTANCE_BY_ID_DISPATCH_SUCCESS,
                        payload: response.data
                    }
                );
            }).catch((e) => {
            dispatch(
                {
                    type: actions.FETCH_BO_INSTANCE_BY_ID_DISPATCH_ERROR,
                }
            );
            history.push(`${process.env.ENV_PREFIX}/managedata`);
        })
    }
};


export const createInstance = async (id, dataView, dto): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.post(`boi/${id}?dataView=${dataView}`, dto)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const deleteInstance = async (id): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.delete(`boi/${id}`)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const deleteInstancesByIds = async (ids: number[]): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.delete(`boi`, {data: ids})
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const deleteSpecification = async (id): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.delete(`specification/${id}`, {}, {
            key: "deleteSpecification",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Specification deleted successfully."
        })
    } catch (e) {
        throw e;
    }
};


export const createInstanceRelationship = async (dto: {
    fromBoInstanceId: number;
    toBoInstanceId: number
    relTypeId: number
}, excludeSpinner?: boolean): Promise<AxiosResponse> => {
    return await ActionSpinner.post(`boi/rel`, dto, {}, {
        key: "createInstanceRelationship",
        showOnError: true,
        excludeSpinner
    })
};


export const getInstanceById = async (id, dataView, spinner?: boolean): Promise<AxiosResponse> => {
    try {
        if (spinner) {
            return await ActionSpinner.get(`boi/${id}/?dataView=${dataView}`, {}, {
                key: "getInstanceById",
                showOnError: true
            });
        } else {
            return await Axios.instance.get(`boi/${id}/?dataView=${dataView}`);
        }
    } catch (e) {
        showError(e);
        throw e;
    }
};


export const getRelationshipsById = async (id): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.get(`boi/${id}/relationships`);
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const getInstancesRelationshipsById = async (id: number, relTypeId: number, includeAttributes: boolean): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.get(`boi/${id}/relationships?relTypeId=${relTypeId}&includeAttributes=${includeAttributes}`)
    } catch (e) {
        showError(e);
        throw e;
    }
};


export const deleteInstanceRelationship = async (id, excludeSpinner?: boolean): Promise<AxiosResponse> => {
    return await ActionSpinner.delete(`boi/rel/${id}`, {}, {
        key: "deleteInstanceRelationship",
        showOnError: true,
        excludeSpinner
    });
};

export const updateInstance = async (id, dataView, dto): Promise<AxiosResponse> => {
    return await ActionSpinner.put(`boi/${id}?dataView=${dataView}`, dto, {}, {
        key: "updateInstance",
        showOnError: true
    });
};

export const createBoInstance = async (id: number, dataView: string, dto: any): Promise<AxiosResponse> => {
    return await ActionSpinner.post(`boi/${id}?dataView=${dataView}`, dto, {}, {
        key: "createBoInstance",
        showOnError: true
    });
};

export const getBoInstanceRelationships = async (id: number): Promise<AxiosResponse> => {
    return Axios.instance.get(`boi/${id}/relationships`);
};

export const getAllFilesByInstanceId = async (id: number): Promise<AxiosResponse> => {
    return Axios.instance.get(`boi/${id}/file/all`);
};

export const startDataLoadJob = async (jobId: number): Promise<AxiosResponse> => {
    return Axios.instanceV2.get(`data/data-load-job/${jobId}/run`);
};

export const transferInferenceMismatchRecords = async (body: any): Promise<AxiosResponse> => {
    return Axios.instanceV2.post(`data/inference-transfer`, body);
};

export const getLogs = async (body: any): Promise<AxiosResponse> => {
    return Axios.instanceV2.post(`audit-log?size=1000&page=0&sort=stamp,desc`, body);
};

export const exportLogs = async (body: any): Promise<AxiosResponse> => {
    return Axios.instanceV2.post(`audit-log/export`, body, {responseType: "blob"});
};

export const getNotificationLogsByInstanceId = async (typeKey: string, instanceId: number): Promise<AxiosResponse> => {
    return Axios.instanceV2.get(`data/${typeKey}/instance/${instanceId}/notification-log?page=0&size=100`)
};

export const attachFileToInstance = async (instanceId, file): Promise<AxiosResponse> => {
    try {
        const formData = new FormData();
        formData.append('attachment', file);
        return await Axios.instance.post(`boi/${instanceId}/file/upload?instanceName=${file.name}`, formData, {
            headers: {
                'accept': 'application/json'
            }
        });
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const cloneBoInstance = async (boKey: number, body: any): Promise<AxiosResponse> => {
    return await ActionSpinner.post(`data/${boKey}/clone`, body, {}, {
        key: "cloneBoInstance",
        showOnError: true
    }, false);
};

export const attachFileToInstanceById = async (id: number, file: File, isPublic?:boolean): Promise<AxiosResponse> => {
    const spinnerKey = "attachFile";
    store.dispatch(setSpinner(spinnerKey));

    if (!isPublic) {
        isPublic = false;
    }

    const config = {
        onUploadProgress: progressEvent => {
            store.dispatch({
                type: spinnerActions.SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD,
                payload: {
                    message: "File uploading...",
                    done: progressEvent.loaded,
                    total: progressEvent.total,
                    complete: (progressEvent.loaded / progressEvent.total * 100) || 0
                }
            });
        },
        headers: {
            "Accept": "application/json",
        },
    };
    const formData = new FormData();
    formData.append('attachment', file);
    return ActionSpinner.post(`boi/${id}/file/upload?instanceName=${file.name}&isPublic=${isPublic}`, formData, config, {
        key: spinnerKey,
        showOnError: true
    })
};

export const uploadFile = async (file: File, isPublic: boolean): Promise<AxiosResponse> => {
    const spinnerKey = "uploadFile";
    store.dispatch(setSpinner(spinnerKey));

    const config = {
        onUploadProgress: progressEvent => {
            store.dispatch({
                type: spinnerActions.SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD,
                payload: {
                    message: "File uploading...",
                    done: progressEvent.loaded,
                    total: progressEvent.total,
                    complete: (progressEvent.loaded / progressEvent.total * 100) || 0
                }
            });
        },
        headers: {
            "Accept": "application/json",
        },
    };
    const formData = new FormData();
    formData.append('file', file);
    return ActionSpinner.post(`boi/file/upload?instanceName=${file.name}&isPublic=${isPublic}`, formData, config, {
        key: spinnerKey,
        showOnError: false
    })
};

export const uploadFiles = async (requests: any) => {
    const [...responses] = await Promise.all(requests);
    return responses;
};

export const attachFileToInstances = async (ids: number[], file): Promise<AxiosResponse[]> => {
    const spinnerKey = "attachFileToInstances";
    store.dispatch(setSpinner(spinnerKey));

    const config = {
        onUploadProgress: progressEvent => {
            store.dispatch({
                type: spinnerActions.SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD,
                payload: {
                    message: "File uploading...",
                    done: progressEvent.loaded,
                    total: progressEvent.total,
                    complete: (progressEvent.loaded / progressEvent.total * 100) || 0
                }
            });
        },
        headers: {
            "Accept": "application/json",
        },
    };
    const formData = new FormData();
    formData.append('attachment', file);
    return await ActionSpinner.all(ids.map(id => Axios.instance.post(`boi/${id}/file/upload?instanceName=${file.name}`, formData, config)), {
        key: spinnerKey,
        showOnError: true
    });
};

export const deleteInstanceRelationships = async (ids): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.delete(`boi/relationships`, {data: ids})
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const addTagsToInstance = async (id: number, tags: string[]): Promise<AxiosResponse> => {
    return await ActionSpinner.post(`boi/${id}/tag`, tags, {}, {key: "addTagsToBoInstance", showOnError: true})
};

export const removeTagsFromInstance = async (id: number, tags: string[]): Promise<AxiosResponse> => {
    return await ActionSpinner.delete(`boi/${id}/tag`, {data: tags}, {
        key: "removeTagsToInstance",
        showOnError: true
    })
};


export const addTagsToInstances = async (ids: number[], tags: string[]): Promise<AxiosResponse[]> => {
    try {
        return await Axios.all(ids.map(id => Axios.instance.post(`boi/${id}/tag`, tags)))
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const importSpecification = async (file: File, productId: number, type: string, designId?: number): Promise<AxiosResponse> => {
    try {
        const formData = new FormData();
        formData.append('attachment', file);
        if (designId) {
            return await ActionSpinner.post(`specification/${productId}/import?designId=${designId}&type=${type}`, formData, {}, {
                key: "importSpecification",
                showOnError: true,
                showOnSuccess: true,
                onSuccessMessage: "Import finished successfully."
            });
        } else {
            return await ActionSpinner.post(`specification/${productId}/import?type=${type}`, formData, {}, {
                key: "importSpecification",
                showOnError: true,
                showOnSuccess: true,
                onSuccessMessage: "Import finished successfully."
            });
        }
    } catch (e) {
        throw e;
    }
};

export const reimportSpecFile = async (instanceId: number, file: File, type: string): Promise<AxiosResponse> => {
    try {
        const formData = new FormData();
        formData.append('attachment', file);
        return await ActionSpinner.post(`specification/${instanceId}/reimport?type=${type}`, formData, {}, {
            key: "reimportSpecFile",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Reimport finished successfully."
        });
    } catch (e) {
        throw e;
    }
};

export const getComplianceMatrix = async (complianceMatrixId: number, type?: string): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.get(`specification/compliance-matrix/${complianceMatrixId}?type=${type ? type : "SingleValue"}`);
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const getSpecificationMetrics = async (specificationId: number): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.get(`specification/${specificationId}/metrics`);
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const exportSpecification = async (specificationId: number): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.get(`specification/${specificationId}/export`, {responseType: "blob"}, {
            key: "exportSpecification",
            showOnError: true
        });
    } catch (e) {
        throw e;
    }
};

export const exportComplianceMatrix = async (id: number, type: string): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.get(`specification/compliance-matrix/${id}/export?type=${type}`, {responseType: "blob"}, {
            key: "exportSpecification",
            showOnError: true
        });
    } catch (e) {
        throw e;
    }
};

export const getBoClassById = async (id: number, key?: string): Promise<AxiosResponse[]> => {
    try {
        return await ActionSpinner.all([Axios.instance.get(`boc/${id}`), Axios.instance.get(`boc/${id}/relationships`)], {
            key: key || "getBoClassById",
            showOnError: true
        })
    } catch (e) {
        throw e;
    }
};

export const setComplianceMatrixGoverningSpec = async (matrixId: number, specId: string): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.post(`specification/compliance-matrix/${matrixId}/governing-spec/${specId}`, {}, {}, {
            key: "setComplianceMatrixGoverningSpec",
            showOnError: true
        });
    } catch (e) {
        throw e;
    }
};

export const getIsnGlobalParams = async (): Promise<AxiosResponse[]> => {
    try {
        return await ActionSpinner.all([
            Axios.instance.get(`global-params/BASE_URL`),
            Axios.instance.get(`global-params/SEARCH_TEXT_STOP_WORDS`),
            Axios.instance.get(`global-params/SQL_THRESHOLD_IN_MILLISECONDS`)
        ], {
            key: "getIsnGlobalParams",
            showOnError: true
        })
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const updateSearchTextStopWords = async (words: string[]): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.post(`global-params/stop-words`, words, {}, {
            key: "updateSearchTextStopWords",
            showOnError: true
        });
    } catch (e) {
        throw e;
    }
};

export const updateBaseUrl = async (baseUrl: string): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.post(`global-params/base-url?baseUrl=${baseUrl}`, {}, {}, {
            key: "updateBaseUrl",
            showOnError: true
        });
    } catch (e) {
        throw e;
    }
};

export const updateSqlThreshold = async (miliseconds: number): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.post(`global-params/sql-threshold?threshold=${miliseconds}`, {}, {}, {
            key: "updateBaseUrl",
            showOnError: true
        });
    } catch (e) {
        throw e;
    }
};

export const addBOInstanceTags = (currentInstance, originalInstance, tags) => {
    const msg = "Instance Tags Are Being Created.";
    return (dispatch) => {
        dispatch({type: actions.UPDATE_BO_INSTANCE_TAGS_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.post(`boi/${currentInstance.id}/tag`, [...tags])
            .then(response => {
                dispatch(
                    {
                        type: actions.UPDATE_BO_INSTANCE_TAGS_DISPATCH_SUCCESS,
                        payload: {currentInstance, originalInstance, data: response.data}
                    }
                );
                dispatch(disableSpinner(msg));
                toastr.success("Tag/s Added Successfully.")
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_BO_INSTANCE_TAGS_DISPATCH_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const deleteBOInstanceTags = (currentInstance, originalInstance, tags) => {
    const msg = "Instance Tags Are Being Deleted.";
    return (dispatch) => {
        dispatch({type: actions.UPDATE_BO_INSTANCE_TAGS_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.delete(`boi/${currentInstance.id}/tag`, {data: [...tags]})
            .then(response => {
                dispatch(
                    {
                        type: actions.UPDATE_BO_INSTANCE_TAGS_DISPATCH_SUCCESS,
                        payload: {currentInstance, originalInstance, data: response.data}
                    }
                );
                dispatch(disableSpinner(msg));
                toastr.success("Tag/s Deleted Successfully.")
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_BO_INSTANCE_TAGS_DISPATCH_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const fetchAllDataViews = () => {
    const msg = "Data Views Being Fetched.";
    return (dispatch) => {
        dispatch({type: actions.FETCH_ALL_DATA_VIEWS_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.get(`boc/dataView/all`)
            .then(response => {
                dispatch(
                    {
                        type: actions.FETCH_ALL_DATA_VIEWS_DISPATCH_SUCCESS,
                        payload: response.data
                    }
                );
                dispatch(disableSpinner(msg));
            }).catch((e) => {
            dispatch(
                {
                    type: actions.FETCH_ALL_DATA_VIEWS_DISPATCH_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const fetchAllDataViewsByBusinessObjectId = (id: number, args?: object) => {
    const msg = "Data Views Being Fetched.";
    return (dispatch) => {
        dispatch({type: actions.FETCH_ALL_DATA_VIEWS_BY_BOC_ID_PENDING});
        dispatch(enableSpinner(msg));
        ActionSpinner.get(`boc/${id}/dataView`, {}, {key: "fetchAllDataViewsByBusinessObjectId", showOnError: true})
            .then(response => {
                dispatch(
                    {
                        type: actions.FETCH_ALL_DATA_VIEWS_BY_BOC_ID_SUCCESS,
                        payload: response.data,
                        args
                    }
                );
                dispatch(disableSpinner(msg));
            }).catch((e) => {
            dispatch(
                {
                    type: actions.FETCH_ALL_DATA_VIEWS_BY_BOC_ID_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const getAllDataViewsByBOId = async (id: number): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.get(`boc/${id}/dataView`)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const createDataView = (id: number, args: { dto: object, event: string }, callBack: any, errCallBack: any) => {
    const msg = "Data View Is Being Created.";
    return (dispatch) => {
        dispatch({type: actions.CREATE_DATA_VIEW_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.post(`boc/${id}/dataView`, args)
            .then(response => {
                callBack(response);
                dispatch(disableSpinner(msg));
                toastr.success("Data View Created Successfully")
            }).catch((e) => {
            dispatch(disableSpinner(msg));
            showError(e);
            errCallBack(e);
        })
    }
};

export const updateDataView = (id, args, callBack: any, errCallBack: any) => {
    const msg = "Data View Is Being Updated.";
    return (dispatch) => {
        dispatch({type: actions.UPDATE_DATA_VIEW_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.put(`boc/dataView/${id}`, args)
            .then(response => {
                callBack(response);
                dispatch(disableSpinner(msg));
                toastr.success("Data View Updated Successfully")
            }).catch((e) => {
            dispatch(disableSpinner(msg));
            showError(e);
            errCallBack(e);
        })
    }
};

export const deleteDataView = (id, callBack: any, errCallBack: any) => {
    const msg = "Data View Is Being Deleted.";
    return (dispatch) => {
        dispatch({type: actions.DELETE_DATA_VIEW_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.delete(`boc/dataView/${id}`)
            .then(response => {
                callBack(response);
                dispatch(disableSpinner(msg));
                toastr.success("Data View Deleted Successfully")
            }).catch((e) => {
            dispatch(disableSpinner(msg));
            showError(e);
            errCallBack(e);
        })
    }
};

export const createColumnsOfDataView = (id, dto, callBack, errCallBack) => {
    const msg = "Data View Columns Are Being Created.";
    return (dispatch) => {
        dispatch({type: actions.CREATE_COLUMNS_OF_DATA_VIEW_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.post(`boc/dataView/${id}/columns`, dto)
            .then(response => {
                callBack(response);
                dispatch(disableSpinner(msg));
                toastr.success("Columns of Data View Updated Successfully");
            }).catch((e) => {
            errCallBack(e);
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const downloadFile = (id: number) => {
    return () => {
        saveAs(`${Axios.API_BASE_URL}/boi/${id}/file/download`);
    }
};

export const downloadFileById = async (id: number): Promise<AxiosRequestConfig> => {
    return ActionSpinner.get(`boi/${id}/file/download`, {responseType: "blob"}, {
        key: "downloadFileById",
        showOnError: true
    })
};

export const downloadFilesByIds = async (ids: number[]): Promise<AxiosResponse> => {
    return await ActionSpinner.get(`boi/file/zip?ids=${ids.join("&ids=")}`, {responseType: "blob"}, {
        key: "downloadFilesByIds",
        showOnError: true
    })
};

export const downloadAllFilesByInstanceId = async (id: number): Promise<AxiosResponse> => {
    return await ActionSpinner.get(`boi/${id}/file/all/zip`, {responseType: "blob"}, {
        key: "downloadAllFilesByInstanceId",
        showOnError: true
    });
};

export const deleteBoInstancesByIds = async (ids: number[]): Promise<AxiosResponse[]> => {
    return await ActionSpinner.all(ids.map(id => {
        return Axios.instance.delete(`boi/${id}`)
    }), {key: "deleteInstancesByIds", showOnError: true})
};

export const deleteBoRelationshipsByIds = async (ids: number[]): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`boi/relationships`, {data: ids}, {
        key: "deleteBoRelationshipsByIds",
        showOnError: true
    })
};

export const downloadZip = (ids: number[], fileName: string) => {
    return () => {
        const link = document.createElement('a');
        link.setAttribute("href", `${Axios.API_BASE_URL}/boi/file/zip?ids=${ids.join("&ids=")}`);
        link.setAttribute("download", `${fileName}_${Date.now()}_Attachment.zip`);
        link.setAttribute("style", "display: none;");
        document.body.appendChild(link);
        link.click();
    }
};

export const fetchAllTags = (callBack?: any) => {
    return (dispatch) => {
        dispatch({type: actions.FETCH_ALL_TAGS_PENDING});
        Axios.instance.get(`tags`)
            .then(response => {
                dispatch(
                    {
                        type: actions.FETCH_ALL_TAGS_DISPATCH_SUCCESS,
                        payload: response.data
                    }
                );
                if (callBack) {
                    callBack(response.data);
                }
            }).catch((e) => {
            dispatch(
                {
                    type: actions.FETCH_ALL_TAGS_DISPATCH_ERROR,
                }
            );
            if (callBack) {
                callBack(e);
            } else {
                showError(e);
            }
        })
    }
};

export const getBoInstanceData = async (args: { instanceId: number, dataView: string }): Promise<AxiosResponse[]> => {
    return await ActionSpinner.all([
            Axios.instance.get(`boc/all`),
            Axios.instance.get(`boi/${args.instanceId}/?dataView=${args.dataView}&excludeRelationships=true`)
        ],
        {key: "getBoInstanceData", showOnError: true})
};

export const getBoInstanceDiagramData = async (args: { instanceId: number, layers: number, limit: number }): Promise<AxiosResponse> => {
    return await ActionSpinner.get(`boi/${args.instanceId}/relationships/${args.layers}/${args.limit}`, {}, {
        key: "getBoInstanceDiagramData",
        showOnError: true
    })
};

export const getInstanceRelationshipsByIdLayersPageRelType = async (id: number, layers: number, page: number, relTypeId: number, limit: number): Promise<AxiosResponse> => {
    return await ActionSpinner.get(`boi/${id}/relationships/${relTypeId}/${layers}/${page}/${limit}`, {}, {
        key: "getInstanceRelationshipsByIdLayersPageRelType",
        showOnError: true
    })
};

export const getBoInstanceById = async (id: number, dataView: string): Promise<AxiosResponse> => {
    return ActionSpinner.get(`boi/${id}/?dataView=${dataView}`, {}, {key: "getBoInstanceById", showOnError: true});
};

export const getBusinessObjects = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`boc/all`, {}, {key: "getBusinessObjects", showOnError: true});
};

export const getBusinessObjectClassById = async (id: number) => {
    return await ActionSpinner.get(`boc/${id}`, {}, {key: "getBusinessObjectClassById", showOnError: true});
};

export const getRelationshipTypesByBoId = async (id: number): Promise<AxiosResponse> => {
    return ActionSpinner.get(`boc/${id}/relationships`, {}, {key: "getRelationshipTypesByBoId", showOnError: true});
};

export const fetchAllBOCLayouts = () => {
    const msg = "Diagrams Are Being Fetched.";
    return (dispatch) => {
        dispatch({type: actions.FETCH_ALL_BOC_LAYOUTS_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.get(`bol/all`)
            .then(response => {
                dispatch(
                    {
                        type: actions.FETCH_ALL_BOC_LAYOUTS_SUCCESS,
                        payload: response.data
                    }
                );
                dispatch(disableSpinner(msg));
            }).catch((e) => {
            dispatch(
                {
                    type: actions.FETCH_ALL_BOC_LAYOUTS_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const fetchBOCLayoutById = (id) => {
    const msg = "Diagram Is Being Fetched.";
    return (dispatch) => {
        dispatch({type: actions.FETCH_BOC_LAYOUT_BY_ID_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.get(`bol/${id}`)
            .then(response => {
                dispatch(
                    {
                        type: actions.FETCH_BOC_LAYOUT_BY_ID_SUCCESS,
                        payload: response.data
                    }
                );
                dispatch(disableSpinner(msg));
            }).catch((e) => {
            dispatch(
                {
                    type: actions.FETCH_BOC_LAYOUT_BY_ID_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const createBOCLayout = (layout) => {
    const msg = "Diagram is being saved.";
    return (dispatch) => {
        dispatch({type: actions.CREATE_BOC_LAYOUT_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.post(`bol/`, layout)
            .then(response => {
                dispatch(
                    {
                        type: actions.CREATE_BOC_LAYOUT_SUCCESS,
                        payload: response.data
                    }
                );
                dispatch(disableSpinner(msg));
                toastr.success("Diagram saved successfully");
            }).catch((e) => {
            dispatch(
                {
                    type: actions.CREATE_BOC_LAYOUT_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const setCurrentBOCLayout = (layout) => {
    return (dispatch) => {
        dispatch(
            {
                type: actions.SET_CURRENT_BOC_LAYOUT,
                payload: layout
            }
        );
    };
};

export const updateBOCLayout = (id, layout) => {
    const msg = "Diagram is being updated.";
    return (dispatch) => {
        dispatch({type: actions.UPDATE_BOC_LAYOUT_BY_ID_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.put(`bol/${id}`, layout)
            .then(response => {
                dispatch(
                    {
                        type: actions.UPDATE_BOC_LAYOUT_BY_ID_SUCCESS,
                        payload: response.data
                    }
                );
                dispatch(disableSpinner(msg));
                toastr.success("Diagram updated successfully");
            }).catch((e) => {
            dispatch(
                {
                    type: actions.UPDATE_BOC_LAYOUT_BY_ID_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const deleteBOCLayout = (id) => {
    const msg = "Diagram is being deleted.";
    return (dispatch) => {
        dispatch({type: actions.DELETE_BOC_LAYOUT_BY_ID_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.delete(`bol/${id}`)
            .then(() => {
                dispatch(
                    {
                        type: actions.DELETE_BOC_LAYOUT_BY_ID_SUCCESS,
                        payload: id
                    }
                );
                dispatch(disableSpinner(msg));
                toastr.success("Diagram deleted successfully");
            }).catch((e) => {
            dispatch(
                {
                    type: actions.DELETE_BOC_LAYOUT_BY_ID_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const setHiddenAndModifiedBOCs = (hiddenAndModifiedBOCs) => {
    return (dispatch) => {
        setTimeout(() => {
            dispatch({
                type: actions.SET_HIDDEN_AND_MODIFIED_BOCS_FOR_LAYOUT,
                payload: hiddenAndModifiedBOCs
            })
        }, 1);
    }
};

export const updateBOCsInLayout = (bocs) => {
    return (dispatch) => {
        dispatch({
            type: actions.UPDATE_BOC_IN_LAYOUT,
            payload: bocs
        })
    }
};

export const manageDataExport = async (boc, dataView, fileType, filter, multiValueFormat, q, sort): Promise<AxiosResponse> => {
    return await ActionSpinner.get(`/boi/data/${boc.id}/export?dataView=${dataView}&fileFormat=${fileType}&&filter=${urlencode(filter)}&multiValueFormat=${multiValueFormat}&q=${urlencode(q)}&sort=${urlencode(sort)}`, {responseType: "blob"}, {
        key: "manageDataExport",
        showOnError: true
    },true)
};

export const updateIncrementingAttribute = async (id: number, dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.put(`boc/attribute/${id}/incrementing`, dto, {}, {
        key: "updateIncrementingAttribute",
        showOnError: true
    })
};

export const manageDataImport = async (boc, dataView, multiValueFormat, file): Promise<AxiosResponse> => {
    const spinnerKey = "manageDataImport";
    store.dispatch(setSpinner(spinnerKey));
    const config = {
        onUploadProgress: progressEvent => {
            store.dispatch({
                type: spinnerActions.SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD,
                payload: {
                    message: "File uploading...",
                    done: progressEvent.loaded,
                    total: progressEvent.total,
                    complete: (progressEvent.loaded / progressEvent.total * 100) || 0
                }
            });
        },
        headers: {
            "Accept": "application/json",
            'Content-Type': 'multipart/form-data'
        },
    };
    const formData = new FormData();
    formData.append('file', file);
    return await ActionSpinner.post(`boi/data/${boc.id}/import?dataView=${dataView}&multiValueFormat=${multiValueFormat}`, formData, config, {
        key: spinnerKey,
        showOnError: true
    })
};

export const importV2 = async (file, multiValueFormat, typeKey): Promise<AxiosResponse> => {
    const spinnerKey = "importV2";
    store.dispatch(setSpinner(spinnerKey));
    const config = {
        onUploadProgress: progressEvent => {
            store.dispatch({
                type: spinnerActions.SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD,
                payload: {
                    message: "File uploading...",
                    done: progressEvent.loaded,
                    total: progressEvent.total,
                    complete: (progressEvent.loaded / progressEvent.total * 100) || 0
                }
            });
        },
        headers: {
            "Accept": "application/json",
            'Content-Type': 'multipart/form-data'
        },
    };
    const formData = new FormData();
    formData.append('file', file);
    formData.append('multiValueFormat', multiValueFormat);
    return await ActionSpinner.post(`data/${typeKey}/import/start`, formData, config, {
        key: spinnerKey,
        showOnError: true
    }, false)
};

export const importAttributeValues = async (id, file): Promise<AxiosResponse> => {
    const spinnerKey = "importValues";
    store.dispatch(setSpinner(spinnerKey));
    const config = {
        onUploadProgress: progressEvent => {
            store.dispatch({
                type: spinnerActions.SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD,
                payload: {
                    message: "File uploading...",
                    done: progressEvent.loaded,
                    total: progressEvent.total,
                    complete: (progressEvent.loaded / progressEvent.total * 100) || 0
                }
            });
        },
        headers: {
            "Accept": "application/json",
            'Content-Type': 'multipart/form-data'
        },
    };
    const formData = new FormData();
    formData.append('file', file);
    return await ActionSpinner.post(`administrator/attribute/${id}/values/import`, formData, config, {
        key: spinnerKey,
        showOnError: true
    }, false)
};

export const importNaturalKeys = async (importId,naturalKeys): Promise<AxiosResponse> => {
    let stringKeys = '';
    naturalKeys.forEach((key,index) => {
        stringKeys += 'naturalKeys=' + key;
        if (index !== naturalKeys.length - 1) {
            stringKeys += '&';
        }
    });
    try {
        return await ActionSpinner.post(`/data/import/${importId}/submit?${stringKeys}`, {}, {}, {
            key: 'importNaturalKeys',
            showOnError: true
        }, false)
    } catch (e) {
        throw e;
    }
};

export const submit = async (importId): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.post(`/data/import/${importId}/submit`, {}, {}, {
            key: 'submit',
            showOnError: true
        }, false)
    } catch (e) {
        throw e;
    }
};


export const layoutSaveObjects = (saveModel) => {
    return (dispatch) => {
        let msg = "Objects Are Being Saved.";
        dispatch(enableSpinner(msg));
        dispatch({type: actions.LAYOUT_SAVE_OBJECTS_PENDING});

        Axios.instance.post('updateModel', saveModel)
            .then(response => {
                dispatch(
                    {
                        type: actions.LAYOUT_SAVE_OBJECTS_SUCCESS,
                        payload: response.data
                    }
                );
                dispatch(disableSpinner(msg));
                let message = generateLayoutObjectsSaveMessage(response.data);
                if (message.success != "") {
                    toastr.success(message.success);
                }
                if (message.fail != "") {
                    toastr.error(message.fail);
                }

            }).catch((e) => {
            dispatch(
                {
                    type: actions.LAYOUT_SAVE_OBJECTS_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const fetchPartsToCompare = (parts) => {
    const msg = "Parts To Compare Are Being Fetched.";
    const ids = new Set(parts);
    return (dispatch) => {
        dispatch({type: actions.FETCH_PARTS_TO_COMPARE_PENDING});
        dispatch(enableSpinner(msg));
        Axios.instance.get(`part/compare?ids=${Array.from(ids).join('&ids=')}`)
            .then(response => {
                dispatch(
                    {
                        type: actions.FETCH_PARTS_TO_COMPARE_DISPATCH_SUCCESS,
                        payload: response.data
                    }
                );
                dispatch(disableSpinner(msg));
            }).catch((e) => {
            dispatch(
                {
                    type: actions.FETCH_PARTS_TO_COMPARE_DISPATCH_ERROR,
                }
            );
            dispatch(disableSpinner(msg));
            showError(e);
        })
    }
};

export const deleteInstances = (ids: number[], successCallBack: any) => {
    return (dispatch) => {
        dispatch({type: actions.DELETE_BO_INSTANCES_PENDING});
        ActionSpinner.delete(`boi`, {data: ids}, {
            key: "deleteInstances",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: "Selected instances are deleted successfully."
        })
            .then(response => {
                dispatch(
                    {
                        type: actions.DELETE_BO_INSTANCES_DISPATCH_SUCCESS,
                        payload: response.data
                    }
                );
                if (successCallBack) {
                    successCallBack();
                }
            });
    }
};

export const terminateProcess = (id: string) => {
    Axios.instance.post(`process/terminate?uuid=${id}`)
        .then(() => {
            toastr.success("Process interrupted successfully.", null, {preventDuplicates: false})
        }).catch((e) => {
        showError(e);
    })
};

export const mergeAttributeValues = (attributeId: number, dto: object, successCallBack?: any, rejectCallBack?: any) => {
    return (dispatch) => {
        Axios.instance.put(`boc/attribute/${attributeId}/values/merge`, dto)
            .then((response: any) => {
                if (successCallBack) {
                    successCallBack(response);
                }
            }).catch(e => {
            if (rejectCallBack) {
                rejectCallBack(e);
            } else {
                showError(e);
            }
        })
    }
};

export const mergeTags = (dto: object, successCallBack?: any, rejectCallBack?: any) => {
    return (dispatch) => {
        Axios.instance.post(`tags/merge`, dto)
            .then((response: any) => {
                if (successCallBack) {
                    successCallBack(response);
                }
            }).catch(e => {
            if (rejectCallBack) {
                rejectCallBack(e);
            } else {
                showError(e);
            }
        })
    }
};

export const mergeInstances = async (dto: object, boKey: any): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.post(`data/${boKey}/merge`, dto, {}, {
            key: 'mergeRecords',
            showOnError: true
        }, false)
    } catch (e) {
        throw e;
    }
};

export const deleteTags = (ids: number[], successCallBack?: any, rejectCallBack?: any) => {
    return (dispatch) => {
        ActionSpinner.delete(`tags`, {data: ids}, {
            key: "deleteTags",
            showOnError: true,
            showOnSuccess: true,
            onSuccessMessage: 'Tags deleted successfully.'
        })
            .then((response: any) => {
                if (successCallBack) {
                    successCallBack(response);
                }
            })
    }
};

export const updateTagName = (id: number, name: string, successCallBack?: any, rejectCallBack?: any) => {
    return (dispatch) => {
        Axios.instance.put(`tag/${id}`, {name: name})
            .then((response: any) => {
                if (successCallBack) {
                    successCallBack(response);
                }
            }).catch(e => {
            if (rejectCallBack) {
                rejectCallBack(e);
            } else {
                showError(e);
            }
        })
    }
};

export const getUserMetadata = async (): Promise<AxiosResponse[]> => {
    return ActionSpinner.all([
        Axios.instanceV2.get("tenant"),
        Axios.instanceV2.get("user/roles")
    ], {key: "getUserMetadata", showOnError: true})
};

const saveAs = function (url: string) {
    const link = document.createElement('a');
    link.setAttribute("href", url);
    link.setAttribute("download", 'test.zip');
    link.setAttribute("style", "display: none;");
    document.body.appendChild(link);
    link.click();
};

const showError = data => {
    const {response} = data;
    try {
        toastr.error(myxss.process(response.data.message));
    } catch (ex) {
        console.error(data.stack);
    }
};

const generateLayoutObjectsSaveMessage = (payload) => {
    let message = {success: "", fail: ""};
    if (payload.create.succeeded.boc.length > 0) {
        message.success += "Business objects successfully created:<br/> ";
        payload.create.succeeded.boc.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ". <br/>"
            }
            message.success += b.name + punct;
        });
    }
    if (payload.create.succeeded.relType.length > 0) {
        message.success += "Relationships successfully created:<br/> ";
        payload.create.succeeded.relType.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ". <br/>"
            }
            message.success += b.name + " from " + b.fromBoClass.name + " to " + b.toBoClass.name + punct;
        });
    }

    if (payload.create.failed.boc.length > 0) {
        message.fail += "Business objects failed to create:<br/> ";
        payload.create.failed.boc.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ". <br/>"
            }
            message.fail += b.name + ", cause: " + b.cause + punct;
        });
    }

    if (payload.create.failed.relType.length > 0) {
        message.fail += "Relationships failed to create:<br/> ";
        payload.create.failed.relType.forEach((b, index, array) => {
            let punct = "; <br/> ";
            if (index == array.length - 1) {
                punct = ".<br/>"
            }
            message.fail += b.name + " from " + b.fromBoClass.name + " to " + b.toBoClass.name + ", cause: " + b.cause + punct;
        });
    }

    if (payload.update.succeeded.boc.length > 0) {
        message.success += "Business objects successfully updated:<br/> ";
        payload.update.succeeded.boc.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ". <br/>"
            }
            message.success += b.name + punct;
        });
    }
    if (payload.update.succeeded.relType.length > 0) {
        message.success += "Relationships successfully updated: <br/>";
        payload.update.succeeded.relType.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ". <br/>"
            }
            message.success += b.name + " from " + b.fromBoClass.name + " to " + b.toBoClass.name + ", cause: " + b.cause + punct;
        });
    }

    if (payload.update.failed.boc.length > 0) {
        message.fail += "Business objects failed to update: <br/>";
        payload.update.failed.boc.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ". <br/>"
            }
            message.fail += b.name + " with id " + b.id + ", cause: " + b.cause + punct;
        });
    }

    if (payload.update.failed.relType.length > 0) {
        message.fail += "Relationships failed to update:<br/> ";
        payload.update.failed.relType.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ".<br/>"
            }
            message.fail += b.name + " from " + b.fromBoClass.name + " to " + b.toBoClass.name + ", cause: " + b.cause + punct;
        });
    }

    if (payload.delete.succeeded.boc.length > 0) {
        message.success += "Business objects successfully deleted: <br/>";
        payload.delete.succeeded.boc.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ".<br/>"
            }
            message.success += b.name + punct;
        });
    }
    if (payload.delete.succeeded.relType.length > 0) {
        message.success += "Relationships successfully deleted:<br/> ";
        payload.delete.succeeded.relType.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ".<br/>"
            }
            message.success += b.name + " from " + b.fromBoClass.name + " to " + b.toBoClass.name + punct;
        });
    }

    if (payload.delete.failed.boc.length > 0) {
        message.fail += "Unable to delete business objects: <br/>";
        payload.delete.failed.boc.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ". <br/>"
            }
            message.fail += b.name + " with id " + b.id + ", cause: " + b.cause + punct;
        });
    }

    if (payload.delete.failed.relType.length > 0) {
        message.fail += "Unable to delete relationships:<br/> ";
        payload.delete.failed.relType.forEach((b, index, array) => {
            let punct = "; <br/>";
            if (index == array.length - 1) {
                punct = ". <br/>"
            }
            message.fail += b.name + " from " + b.fromBoClass.name + " to " + b.toBoClass.name + b.id + ", cause: " + b.cause + punct;
        });
    }
    return message;
};

export const saveSearch = async (dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`search`, dto, {}, {
        key: "saveSearch",
        showOnError: true
    }, false)
};

export const deleteSearch = async (searchId: any): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`search?searchId=${searchId}`, {}, {
        key: "deleteSearch",
        showOnError: true
    }, false)
};

export const getRuleEngineOperators = async (): Promise<AxiosResponse> => {
    try {
        return await ActionSpinner.get(`rule-engine/operators-schema`, {}, {
            key: "getRuleEngineOperators",
            showOnError: true
        }, false);
    } catch (e) {
        throw e;
    }
};

export const deleteUser = async (userId: any): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`user/${userId}`, {}, {
        key: "deleteUser",
        showOnError: true
    }, false)
};

export const createUser = async (dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`user/create`, dto, {}, {
        key: "createUser",
        showOnError: true
    }, false)
};

export const inviteUser = async (dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`user/invite`, dto, {}, {
        key: "inviteUser",
        showOnError: true,
        showOnSuccess: true,
        onSuccessMessage: "User invited successfully"
    }, false)
};

export const resetUserPass = async (userID: number): Promise<AxiosResponse> => {
    return ActionSpinner.post(`user/${userID}/send-update-password`, {}, {}, {
        key: "resetPass",
        showOnError: true,
        showOnSuccess: true,
        onSuccessMessage: "Email for resetting password is sent successfully to the selected user."
    }, false)
};

export const editUser = async (userId: number, dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`user/${userId}/edit`, dto, {}, {
        key: "editUser",
        showOnError: true
    }, false)
};

export const assignRoleToUser = async (userId: number, roleId: number): Promise<AxiosResponse> => {
    return ActionSpinner.post(`access-control/user/${userId}/role/${roleId}`, {}, {}, {
        key: "assignRoleToUser",
        showOnError: true
    }, false)
};

export const removeRoleFromUser = async (userId: number, roleId: number): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`access-control/user/${userId}/role/${roleId}`, {}, {
        key: "removeRoleFromUser",
        showOnError: true
    }, false)
};

export const createNewFunctionality = async (dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`functionality`, dto, {}, {
        key: "createFunctionality",
        showOnError: true
    }, false)
};

export const createNewUiRoute = async (dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`access-control/ui-route`, dto, {}, {
        key: "createNewUiRoute",
        showOnError: true
    }, false)
};

export const createNewRole = async (roleName: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`access-control/role?roleName=${roleName}`, {}, {}, {
        key: "createNewRole",
        showOnError: true
    }, false)
};

export const getAllTenants = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`tenant/all`,  {}, {
        key: "getAllTenants",
        showOnError: true
    }, false)
};

export const getAllTenantsPublic = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`public/tenant/all`,  {withCredentials: false}, {
        key: "getAllTenants",
        showOnError: true,
    }, false)
};

export const getTenantContext = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`tenant`,  {}, {
        key: "getTenants",
        showOnError: true
    }, false)
};

export const getAllEndpoints = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`access-control/api-endpoint/all`,  {}, {
        key: "getApiEndpoints",
        showOnError: true
    }, false)
};

export const getAllUIRoutes = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`access-control/ui-route/all?limit=999999`,  {}, {
        key: "getApiEndpoints",
        showOnError: true
    }, false)
};

export const getAllRoles = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`access-control/role/all?limit=999999`,  {}, {
        key: "getAllRoles",
        showOnError: true
    }, false)
};

export const deleteRole = async (roleId: any): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`access-control/role/${roleId}`, {}, {
        key: "deleteRole",
        showOnError: true
    }, false)
};

export const deleteUIRoute = async (routeId: any): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`access-control/ui-route/${routeId}`, {}, {
        key: "deleteUIRoute",
        showOnError: true
    }, false)
};

export const editRouteName= async (routeId: number, routeName: string): Promise<AxiosResponse> => {
    return ActionSpinner.put(`access-control/ui-route/${routeId}?route=${routeName}`, {}, {}, {
        key: "editRouteName",
        showOnError: true
    }, false)
};

export const getAllFunctionalities = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`functionality/all`,  {}, {
        key: "getAllFunctionalities",
        showOnError: true
    }, false)
};

export const deleteFunctionality= async (funcId: any): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`functionality/${funcId}`, {}, {
        key: "deleteFunctionality",
        showOnError: true
    }, false)
};

export const editFunctionality = async (funcId: number, dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.put(`functionality/${funcId}`,  dto, {}, {
        key: "editFunctionality",
        showOnError: true
    }, false)
};

export const editRoleName= async (roleId: number, roleName: string): Promise<AxiosResponse> => {
    return ActionSpinner.put(`access-control/role/${roleId}?roleName=${roleName}`, {}, {}, {
        key: "editRoleName",
        showOnError: true
    }, false)
};

export const getRoleById = async (id: number): Promise<AxiosResponse> => {
    return ActionSpinner.get(`access-control/role/${id}`,  {}, {
        key: "getAllRoles",
        showOnError: true
    }, false)
};

export const assignFunctionalitiesToRole = async (roleId: number, funcsAdded: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`access-control/role/${roleId}/permission`, funcsAdded, {}, {
        key: "assignFunctionalitiesToRole",
        showOnError: true
    }, false)
};

export const editRoleFunctionalities = async (roleId: number, funcsEdited: any): Promise<AxiosResponse> => {
    return ActionSpinner.put(`access-control/role/${roleId}/permission`, funcsEdited, {}, {
        key: "editRoleFunctionalities",
        showOnError: true
    }, false)
};

export const removeFunctionalitiesToRole = async (roleId: number, funcsForDelete: any): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`access-control/role/${roleId}/permission`, {data: funcsForDelete}, {
        key: "removeFunctionalitiesToRole",
        showOnError: true
    }, false)
};

export const createGroup = async (groupName: string): Promise<AxiosResponse> => {
    return ActionSpinner.post(`access-control/group?groupName=${groupName}`, {}, {}, {
        key: "createGroup",
        showOnError: true
    }, false)
};

export const assignRoleToGroup = async (groupId: number, roleId: number): Promise<AxiosResponse> => {
    return ActionSpinner.post(`access-control/group/${groupId}/role/${roleId}`, {}, {}, {
        key: "assignRoleToGroup",
        showOnError: true
    }, false)
};

export const removeRoleFromGroup = async (groupId: number, roleId: number): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`access-control/group/${groupId}/role/${roleId}`, {}, {
        key: "removeRoleFromGroup",
        showOnError: true
    }, false)
};

export const assignUserToGroup = async (groupId: number, userId: number): Promise<AxiosResponse> => {
    return ActionSpinner.post(`access-control/user/${userId}/group/${groupId}`, {}, {}, {
        key: "assignUserToGroup",
        showOnError: true
    }, false)
};

export const removeUserToGroup = async (groupId: number, userId: number): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`access-control/user/${userId}/group/${groupId}`, {}, {
        key: "removeUserToGroup",
        showOnError: true
    }, false)
};

export const deleteGroup = async (groupId: number): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`access-control/group/${groupId}`, {}, {
        key: "deleteGroup",
        showOnError: true
    }, false)
};

export const editGroupName = async (groupId: number, groupName: string): Promise<AxiosResponse> => {
    return ActionSpinner.put(`access-control/group/${groupId}?groupName=${groupName}`, {}, {}, {
        key: "editGroupName",
        showOnError: true
    }, false)
};

export const setUserTimeZone = async (timeZone: string): Promise<AxiosResponse> => {
    return ActionSpinner.post(`/user/time-zone?timeZone=${timeZone}`, {}, {}, {
        key: "setUserTimeZone",
        showOnError: true
    }, false)
};

export const getUserFunctionalities = async (): Promise<AxiosResponse> => {
    try {
        return await Axios.instanceV2.get(`functionality/user/all?allowed=true&limit=999999`)
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const createTenant = async (dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`tenant`, dto, {}, {
        key: "createTenant",
        showOnError: true
    }, false)
};
export const deleteTenant = async (dto: any): Promise<AxiosResponse> => {
   return await ActionSpinner.delete(`tenant`, { data: dto },{
           key: "deleteTenant",
           showOnError: true,
         }, false);

};
export const registerUser = async (dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`/public/register`, dto, {withCredentials: false}, {
        key: "registerUser",
        showOnError: true
    }, false)
};

export const forgotPassword = async (dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`/public/reset-password`, dto, {withCredentials: false}, {
        key: "forgotPassword",
        showOnError: true
    }, false)
};

export const getAllCountries = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`public/countries`,  {withCredentials: false}, {
        key: "getAllCountries",
        showOnError: true,
    }, false)
};

export const denyTenantJoinRequests = async (usersIds: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`/tenant/request/deny`, usersIds, {}, {
        key: "denyTenantJoinRequests",
        showOnError: true
    }, false)
};

export const approveTenantJoinRequests = async (usersIds: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`/tenant/request/approve`, usersIds, {}, {
        key: "approveTenantJoinRequests",
        showOnError: true,
        showOnSuccess: true,
        onSuccessMessage: `${usersIds.length > 1 ? 'Users' : 'User'} approved successfully.`
    }, false)
};

export const joinOrganizationRequest = async (tenantId: number): Promise<AxiosResponse> => {
    return ActionSpinner.post(`tenant/${tenantId}/join`, {}, {}, {
        key: "joinOrganizationRequest",
        showOnError: true,
        showOnSuccess: true,
        onSuccessMessage: 'The request is sent successfully'
    }, false)
};

export const getFile = async (id: number): Promise<AxiosResponse> => {
    try {
        return await Axios.instance.get(`/boi/${id}/file/download/preview`, {responseType: 'blob', timeout: 15000})
    } catch (e) {
        showError(e);
        throw e;
    }
};

export const makeUserSysAdmin = async (userId: number): Promise<AxiosResponse> => {
    return ActionSpinner.post(`user/create-system-administrator/${userId}`, {}, {}, {
        key: "makeUserSysAdmin",
        showOnError: true,
        showOnSuccess: false,
    }, false)
};

export const removeSysAdminRoleFromUser = async (userId: number): Promise<AxiosResponse> => {
    return ActionSpinner.delete(`user/delete-system-administrator/${userId}`, {}, {
        key: "removeSysAdminRoleFromUser",
        showOnError: true,
        showOnSuccess: false,
    }, false)
};

export const setUserNewPass = async (userId: number, dto: any): Promise<AxiosResponse> => {
    return ActionSpinner.post(`user/${userId}/set-password`, dto, {}, {
        key: "setUserNewPass",
        showOnError: true,
        showOnSuccess: false,
    }, false)
};

export const getPublicTenantConfig = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`/public/tenant/config`,  {withCredentials: true}, {
        key: "getPublicTenantConfig",
        showOnError: true,
    }, false)
};

export const getTenantContextConfig = async (): Promise<AxiosResponse> => {
    return ActionSpinner.get(`/tenant/contextConfig`,  {withCredentials: true}, {
        key: "getTenantContextConfig",
        showOnError: true,
    }, false)
};




// WEBPACK FOOTER //
// ./app/actions/boCoreActions.ts